import { difference } from 'collections';
import { LZString } from '@holmescorp/lz-string';
import * as moment from 'moment';
import { publish } from 'pub-sub';
import { db } from '../database';
export const DynlsCacheRecordSchema = '++, &namespace, changed';
export class DynlsCacheRecord {
    namespace;
    data;
    changed;
    constructor(namespace, data, changed) {
        this.namespace = namespace;
        this.data = data;
        this.changed = changed;
    }
    async save() {
        this.changed = moment().toISOString();
        await db.dynls.put(this);
    }
    age() {
        const { changed } = this;
        if (changed) {
            const now = moment();
            const old = moment(changed);
            return now.diff(old, 'hours');
        }
        return 0;
    }
}
const compress = (data) => {
    return LZString.compressToUTF16(JSON.stringify(data));
};
const decompress = (data) => {
    return JSON.parse(LZString.decompressFromUTF16(data) || '{"locales": {"en-us": {}}}');
};
const process_namespaces = (nsnames, ignore, addLpl) => {
    const ignoreNs = new Set(ignore);
    const left = new Set(nsnames.length > 0
        ? typeof nsnames[0] === 'string'
            ? nsnames
            : nsnames.map((v) => v[0])
        : []);
    addLpl && left.add('lpl1');
    return Array.from(difference(left, ignoreNs));
};
export async function namespaces({ svc_call, ignore = [], addLpl = false }) {
    let nsrecord = await db.dynls.where({ namespace: 'namespaces' }).first();
    if (nsrecord === undefined) {
        const nsnames = await svc_call();
        const data = process_namespaces(nsnames, ignore, addLpl);
        nsrecord = new DynlsCacheRecord('namespaces', JSON.stringify(data));
        await nsrecord.save();
    }
    else {
        const { sitews } = window.hcstatic;
        if (sitews.is_open() && nsrecord.age() > 2) {
            const refresh = async () => {
                const nsnames = await svc_call();
                const data = process_namespaces(nsnames, ignore, addLpl);
                db.dynls.where({ namespace: 'namespaces' }).modify({
                    changed: moment().toISOString(),
                    data: JSON.stringify(data)
                });
            };
            refresh();
        }
    }
    return JSON.parse(nsrecord.data);
}
const refresh_active = new Set();
const last_refresh = { value: '', running: false };
const MINUTE = 60 * 1000;
async function announce_refresh() {
    if (last_refresh.running) {
        return;
    }
    last_refresh.running = true;
    const try_announce = () => {
        if (last_refresh.value !== '') {
            const old = moment(last_refresh.value);
            const now = moment();
            if (now.diff(old, 'minutes') > 7) {
                last_refresh.value = '';
                publish('refresh/dynlscache');
            }
        }
    };
    setTimeout(try_announce, 3 * MINUTE);
}
function refresh_bundle({ ns, svc_call }) {
    if (refresh_active.has(ns)) {
        return;
    }
    refresh_active.add(ns);
    const { sitews } = window.hcstatic;
    const refresh = async () => {
        const data = await svc_call();
        db.dynls.where({ namespace: ns }).modify({
            changed: moment().toISOString(),
            data: compress(data)
        });
    };
    const try_refresh = async () => {
        const nsrecord = await db.dynls.where({ namespace: ns }).first();
        if (sitews.is_open() && nsrecord && nsrecord.age() > 2) {
            await refresh();
            last_refresh.value = moment().toISOString();
        }
        setTimeout(try_refresh, 10 * MINUTE);
    };
    try_refresh();
    announce_refresh();
}
export async function get_namespace_bundle({ ns, svc_call }) {
    const { sitews } = window.hcstatic;
    let nsrecord = await db.dynls.where({ namespace: ns }).first();
    if (nsrecord === undefined) {
        const data = await svc_call();
        nsrecord = new DynlsCacheRecord(ns, compress(data));
        await nsrecord.save();
    }
    else if (sitews.is_open() && nsrecord.age() > 2) {
        const data = await svc_call();
        await db.dynls.where({ namespace: ns }).modify({
            changed: moment().toISOString(),
            data: compress(data)
        });
        nsrecord = await db.dynls.where({ namespace: ns }).first();
    }
    refresh_bundle({ ns, svc_call });
    const data = decompress(nsrecord.data);
    const bundle = {
        locales: {},
        messages: data.locales['en-us']
    };
    Object.keys(data.locales).forEach((locale) => {
        bundle.locales[locale] = () => {
            return { ...data.locales[locale] };
        };
    });
    return bundle;
}
